import { render, staticRenderFns } from "./FooterMd.vue?vue&type=template&id=48b29d84&scoped=true&"
import script from "./FooterMd.vue?vue&type=script&lang=js&"
export * from "./FooterMd.vue?vue&type=script&lang=js&"
import style0 from "./FooterMd.vue?vue&type=style&index=0&id=48b29d84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b29d84",
  null
  
)

export default component.exports